import { createAuthClient } from 'better-auth/client';
import { magicLinkClient, jwtClient, twoFactorClient } from 'better-auth/client/plugins';

export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL ?? 'http://localhost:4000',
  plugins: [
    magicLinkClient(),
    jwtClient(),
    // Always load so the client intercepts twoFactorRedirect during sign-in regardless of
    // which users have the Unleash 'two-factor' flag enabled. The flag only gates the
    // enable/disable UI; users who already have 2FA active must always be challenged.
    twoFactorClient({ onTwoFactorRedirect() { window.location.href = '/two-factor'; } }),
  ],
});
